var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 17.13,
    viewBox: "0 0 20 17.13",
    className: "cardArrowContainer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cardArrow",
    id: "arrow-small-left",
    d: "M22.857,28.57H37.143l-4.7-4.7a1.429,1.429,0,0,1,2.014-2.029l6.129,6.143A2.857,2.857,0,0,1,41.428,30h0a2.857,2.857,0,0,1-.843,2l-6.129,6.143a1.429,1.429,0,0,1-2.014-2.029l4.7-4.686H22.857a1.429,1.429,0,1,1,0-2.857Z",
    transform: "translate(-21.429 -21.426)",
    fill: "#3160d4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardArrow);
export default __webpack_public_path__ + "static/media/cardArrow.a4474772e6708c97af806e3dca931c31.svg";
export { ForwardRef as ReactComponent };